export function toCapitalSnakeCase(camelCase: string): string {
  return camelCase.split(/(?=[A-Z])/).join('_').toLocaleUpperCase();
}



// WEBPACK FOOTER //
// ./src/shared/helpers/toCapitalSnakeCase.ts